// src/components/section-templates/ChartGridSection.jsx
import React from "react";
import {
  ResponsiveContainer,
  LineChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  Line,
} from "recharts";
import { MotionContainer, MotionItem } from "../../animations/MotionWrappers";
import "./ChartGridSection.css";

export default function ChartGridSection({ chartData, chartFooter }) {
  // helper to format large numbers as “k”
  const formatK = (value) =>
    value >= 1000 ? `${(value / 1000).toFixed(value % 1000 ? 1 : 0)}k` : value;

  return (
    <section className="chart-grid-section">
      <div className="">
        <MotionContainer className="cg-grid">
          <MotionItem className="cg-panel">
            <h3 className="cg-title">Views Comparison</h3>
            <div className="cg-chart">
              <ResponsiveContainer width="100%" height="100%">
                <LineChart
                  data={chartData}
                  tabIndex={-1}
                  margin={{ top: 60, right: 150, left: 80, bottom: 20 }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="name" />
                  <YAxis
                    domain={[0, "dataMax"]}
                    tickFormatter={formatK}
                    allowDecimals={false}
                    tickCount={6}
                  />
                  <Tooltip />
                  <Legend verticalAlign="bottom" height={24} />
                  <Line
                    dataKey="me"
                    name="My Views"
                    stroke="#2c2c2c"
                    type="monotone"
                    dot={{ r: 3 }}
                    activeDot={{ r: 6 }}
                  />
                  <Line
                    dataKey="thinkmarkets"
                    name="ThinkMarkets"
                    stroke="#8884d8"
                    strokeDasharray="5 5"
                    type="monotone"
                    dot={{ r: 3 }}
                    activeDot={{ r: 6 }}
                  />
                </LineChart>
              </ResponsiveContainer>
            </div>
          </MotionItem>
        </MotionContainer>
        {chartFooter && <div className="cg-footer">{chartFooter}</div>}
      </div>
    </section>
  );
}
